<!-- 修改手机 -->
<template>
    <div class="main-box">
        <div class="content-main">
            <div class="top-info">
                <a-button class="back-btn" @click="goBack">
                    <template #icon>
                        <icon-left/>
                    </template>
                </a-button>
                <span>{{ $t('personal.change_phone') }}</span>
            </div>
            <div class="recommendInvite-content">
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.new_phone_number') }}</span></div>
                    <a-input class="input"
                             autocapitalize="off"
                             v-model="formData.phoneNumber"
                             :placeholder="$t('personal.new_phone_placeholder')" allow-clear long>
                        <template #prefix>
                            <a-select v-model="formData.countryCode"
                                      class="area-select"
                                      :placeholder="formData.countryCode || '86'"
                                      @change="onCountryCodeChange">
                                <a-option v-for="item in countryList" 
                                         :key="item.dialingCode" 
                                         :value="item.dialingCode"
                                         :label="item.dialingCode">
                                    {{ item.dialingCode }}
                                </a-option>
                            </a-select>
                        </template>
                    </a-input>
                </div>
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.new_phone_verification_code') }}</span></div>
                    <a-input class="input"
                             autocapitalize="off"
                             v-model="formData.verificationCode"
                             :placeholder="$t('personal.verification_code_placeholder')" allow-clear long>
                        <template #suffix>
                            <span class="get-code-btn" @click="getVerificationCode">{{ $t('personal.get_verification_code') }}</span>
                        </template>
                    </a-input>
                </div>
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.login_password_input') }}</span></div>
                    <a-input-password class="input"
                                      v-model="formData.password"
                                      :placeholder="$t('personal.login_password_placeholder')"
                                      allow-clear long>
                    </a-input-password>
                </div>
                <div class="recommendInvite-content-box">
                    <a-button class="confirm" @click="handleOk">{{ $t('personal.confirm') }}</a-button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import country from '@/common/area';

export default {
    components: {},
    data() {
        return {
            name: 'changePhone',
            countryList: country.countryList,
            formData: {
                countryCode: '+1',
                phoneNumber: '',
                verificationCode: '',
                password: ''
            }
        };
    },
    methods: {
        goBack() {
            this.$emit("safet-event");
        },
        onCountryCodeChange(value) {
            console.log('选择的区号:', value);
            this.formData.countryCode = value;
        },
        handleOk() {
            console.log('提交表单数据:', this.formData);
            // 这里可以添加表单验证和提交逻辑
        },
        getVerificationCode() {
            if (!this.formData.phoneNumber) {
                this.$message.error(this.$t('personal.phone_number_required'));
                return;
            }
            const fullPhoneNumber = '+' + this.formData.countryCode + this.formData.phoneNumber;
            console.log('获取验证码:', fullPhoneNumber);
            // 这里可以添加获取验证码的API调用
            this.$message.success(this.$t('withdraw.code_sent'));
        }
    },
};
</script>
<style lang="scss" scoped>
@import "./changePhone.scss";

</style>
<style>
.arco-select-dropdown .arco-select-option {
    --color-bg-popup: #1d2126;
    --color-text-1: #fff;
    --color-fill-2: #2a2f37;
    --color-bg-2: #2a2f37;

}

.arco-select-option-active {
    --color-fill-2: #2a2f37;
}

.arco-input-append {
    border: none;
}

.arco-input-wrapper.arco-input-focus {
    background-color: #1d2126;
}

.arco-input-wrapper:hover {
    background-color: #2a2f37;
}
</style>
